import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function TourViewerOpenSvg() {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.85311 0.146894C6.89967 0.19334 6.93661 0.248515 6.96182 0.30926C6.98703 0.370005 7 0.435127 7 0.500894C7 0.566661 6.98703 0.631782 6.96182 0.692528C6.93661 0.753273 6.89967 0.808448 6.85311 0.854894L1.20611 6.50089L6.85311 12.1469C6.89959 12.1934 6.93647 12.2486 6.96163 12.3093C6.98679 12.37 6.99974 12.4352 6.99974 12.5009C6.99974 12.5666 6.98679 12.6317 6.96163 12.6925C6.93647 12.7532 6.89959 12.8084 6.85311 12.8549C6.80662 12.9014 6.75143 12.9383 6.69069 12.9634C6.62995 12.9886 6.56485 13.0015 6.49911 13.0015C6.43336 13.0015 6.36826 12.9886 6.30752 12.9634C6.24678 12.9383 6.19159 12.9014 6.14511 12.8549L0.145106 6.85489C0.0985432 6.80845 0.0616007 6.75327 0.0363941 6.69253C0.0111876 6.63178 -0.00178719 6.56666 -0.00178719 6.50089C-0.00178719 6.43513 0.0111876 6.37001 0.0363941 6.30926C0.0616007 6.24852 0.0985432 6.19334 0.145106 6.14689L6.14511 0.146894C6.19155 0.100331 6.24673 0.0633878 6.30747 0.0381813C6.36822 0.0129749 6.43334 0 6.49911 0C6.56487 0 6.62999 0.0129749 6.69074 0.0381813C6.75149 0.0633878 6.80666 0.100331 6.85311 0.146894Z"
        fill="#91DCE5"
      />
    </svg>
  )
}

export default function TourViewerOpenIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={() => TourViewerOpenSvg()} {...props} />
}
